<template>
  <v-main class="pa-4" fluid>
    <v-row>
      <v-snackbar v-model="snackbar" :timeout="8000" top :color="color" >  {{text}}
        <v-btn color="white" text @click="snackbar = false"> Cerrar </v-btn>
      </v-snackbar>


      <v-col cols="12">

        <v-card class="shadowCard">
          <v-card-title primary-title>
            <span class="text-h5 font-weight-bold"> Subcategorías </span>
            <v-spacer></v-spacer>
            <v-btn color="primary" dark class="mr-2"  @click="nuevaSubcategoria = true"> Nuevo </v-btn>
            <v-btn color="secondary" dark  class="mr-2" @click="initialize()">  Actualizar </v-btn>
          </v-card-title>

          <v-card-text>
            <v-row justify="end">
              <v-spacer></v-spacer>
              <v-col cols="12" md="4" lg="3">
                <v-text-field
                  name="name"
                  label="Buscar"
                  id="id"
                  dense
                  hide-details
                  append-icon="mdi-magnify" 
                  v-model="search"
                  clearable
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <v-data-table
                  :loading="loading"
                  :headers="headers"
                  :items="subcategorias"
                  dense
                >

                  <template v-slot:item.foto="{ item }">
                    <v-img :src="url + item.foto" contain aspect-ratio="2"/>
                  </template>
 
                  <template v-slot:item.editar="{ item }">
                    <v-icon
                      small
                      class="mr-2"
                      @click="editItem(item)"
                      color="blue"
                    >
                      mdi-pencil
                    </v-icon>
                  </template>
                  
                  <template v-slot:item.estatus="{ item }">
                    <v-chip v-if="item.estatus == 1" color="green" dark small>Activo</v-chip>
                    <v-chip v-else color="red" dark small>Inactivo</v-chip>
                  </template>

                 
                </v-data-table>
              </v-col>
            </v-row>

          </v-card-text>

        </v-card>
      </v-col>

      <v-dialog v-model="nuevaSubcategoria" width="600px">
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-card>
            <v-card-title> <span class="text-h5">{{ formTitle }}</span> </v-card-title>

            <v-card-text class="pb-0">
              <v-autocomplete
                v-model="categoria"
                :items="categorias"
                label="Categoría"
                return-object
                item-text="categoria"
                item-value="idcategorias"
                :rules="[v => !!v || 'Campo requerido']"
                filled
                dense
              ></v-autocomplete>

              <v-text-field
                v-model="editedItem.subcategoria"
                label="Subcategoria"
                filled
                dense
                :rules="[v => !!v || 'Campo requerido']"
              ></v-text-field>

              <v-text-field
                v-model="editedItem.precio"
                label="Precio"
                filled
                type="number"
                dense
              ></v-text-field>

              <div v-if="!file && !editedItem.foto">
                <div :class="['dropZone', dragging ? 'dropZone-over' : '']" @dragenter="dragging = true" @dragleave="dragging = false">
                  <div class="dropZone-info" @drag="onChange">
                    <span class="fa fa-cloud-upload dropZone-title"></span>
                    <span class="dropZone-title blue--text"><b>Arrastre el archivo para cargar</b></span>
                    <div class="dropZone-upload-limit-info">
                      <div>Extensión: png, jpg, jpeg, svg</div>
                      <div>Tamaño máximo: 10 MB</div>
                    </div>
                  </div>
                  <input type="file" @change="onChange">
                </div>
              </div>

              <v-btn  v-else color="red" class="mb-2" dense @click="removeFile" fab small dark><v-icon>mdi-delete</v-icon></v-btn>
              <v-img :src="vistaPrevia.url" v-if="vistaPrevia" contain max-height="200"/>
              <!-- <v-img :src="url + editedItem.foto" v-else-if="editedItem.foto" contain max-height="200"/> -->


              <v-checkbox label="Estatus" v-model="editedItem.estatus" >
              </v-checkbox>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red darken-1" outlined @click="nuevaSubcategoria= false"> Cancelar </v-btn>
              <v-btn color="green darken-1" dark  @click="save" > Guardar </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>

      <v-dialog v-model="dialogDelete" max-width="500px">
        <v-card>
          <v-card-title class="text-h5">Are you sure you want to delete this item?</v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
            <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </v-row>
  </v-main>
</template>
<script>
  import  metodos from '@/mixins/metodos.js';

  export default {
    mixins:[metodos],

    data: () => ({
    	loading:false,
      valid: true,
      search:'',
      text:'',
      color:'',
      snackbar: false,
      nuevaSubcategoria: false,
      dialogDelete: false,
      headers: [
        { text: 'Id',            align: 'left',sortable: false, value: 'idsubcategorias'},
        // { text: 'Familia'  ,     align: 'left',sortable: false, value: 'familia'},
        { text: 'Categoria'   ,  align: 'left',sortable: false, value: 'categoria'},
        { text: 'Subcategoria',  align: 'left',sortable: false, value: 'subcategoria'},
        { text: 'Precio'      ,  align: 'left',sortable: false, value: 'precio'},
        { text: 'Estatus',       align: 'left',sortable: false, value: 'estatus'},
        { text: 'Foto'   ,       align: 'left',sortable: false, value: 'foto'},
        { text: 'Editar',        align: 'left',sortable: false, value: 'editar'},
      ],

      subcategorias: [],
      editedIndex: -1,
      editedItem: {
        idsubcategorias:0,
        subcategoria: '',
        idcatego: 0,
        categoria: '',
        estatus: 0,
        precio: 0,
      },
      defaultItem: {
        idsubcategorias:0,
        subcategoria: '',
        idcatego: 0,
        categoria: '',
        estatus: 0,
        precio: 0,
      },

      categorias:[],
      categoria:null,

      file: '',
      dragging: false,
      archivos:null,
      vistaPrevia: null,
      url:'',
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'Nueva Subcategoría' : 'Editar SubCategoría'
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
    },

    created () {
      this.url = this.$http.options.root + 'fotos-epic-grass/'
      this.initialize()
    },

    methods: {

      initialize () {
        this.subcategorias = []
        this.loading = true
        this.$http.get('subcategorias.all').then(response =>{
          this.subcategorias = response.body
          this.subcategorias.forEach(element=>{
            element.estatus == 1 ? true:false
          })
          this.loading = false
        })

        this.$http.get('categorias.activo').then(response =>{
          this.categorias = response.body
        }).catch(error=>{console.log(error)})
      },

      editItem (item) {
        this.editedIndex = this.subcategorias.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.categoria = {idcategorias: this.editedItem.idcatego, categoria: this.editedItem.categoria}
        this.nuevaSubcategoria = true
      },

      deleteItem (item) {
        this.editedIndex = this.subcategorias.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },

      deleteItemConfirm () {
        this.subcategorias.splice(this.editedIndex, 1)
        this.nuevaSubcategoria = false
      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      saveFoto ( ){
        return new Promise((resolve, reject) =>{
          // creamos una variable tipo FormData
          let formData = new FormData();
          //se crea el objeto y se le agrega como un apendice el archivo

          formData.append("file", this.file);
          this.$http.post('categorias.foto', formData).then(response=>{
            resolve( response.body.nombre)  
          })
        })
      },

      async save () {

        let foto = this.editedItem.foto
        if( this.file ){
          foto = await this.saveFoto( ).then( response => response )
        }

        this.editedItem.foto = foto


        if(this.$refs.form.validate()){
          this.editedItem.estatus == false ? 0 : 1
          this.editedItem.idcatego = this.categoria.idcategorias

          if (this.editedIndex > -1) {
            this.$http.put('subcategorias.update/'+ this.editedItem.idsubcategorias, this.editedItem).then(response=>{
              this.text  = 'Categoría actualizada'
              this.snackbar = true
              this.color = 'green'
              this.close( )
              this.initialize()
            })
          } else {
            this.$http.post('subcategorias.add', this.editedItem).then(response=>{
              this.text  = 'Categoría agregada'
              this.snackbar = true
              this.color = 'green'
              this.close( )
              this.initialize()
            })
          }
          this.nuevaSubcategoria = false
        }
      },

      onChange(e) {
        var files = e.target.files || e.dataTransfer.files;
        
        if (!files.length) {
          this.dragging = false;
          return;
        }
        
        this.createFile(files[0]);
      },

      cargarArchivo(){
        if(!this.archivos){ return }
        //mandamos a ocvertir la imagen a base64 pero mandamos el docuemnto, el formdata, el nombre
        this.getBase64(this.archivos)
      },

      getBase64(file) {
        var me = this
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
          me.vistaPrevia = {
            url: reader.result, 
            image_name: file.name
          }
        };
      },

      createFile(file) {
        if (!file.type.match('image.*')) {
          alert('please select txt file');
          this.dragging = false;
          return;
        }
        
        if (file.size > 10000000) {
          alert('please check file size no over 5 MB.')
          this.dragging = false;
          return;
        }
        
        this.file = file;
        this.archivos = file;
        this.getBase64(this.archivos)
        this.dragging = false;
      },

      removeFile() {
        this.vistaPrevia        = null
        this.editedItem.foto    = null
        this.archivos           = null
        this.file               = '';
      },
    },
  }
</script>
<style scoped>
  .dropZone {
    width: 80%;
    height: 150px;
    position: relative;
    border: 2px dashed #eee;
  }

  .dropZone:hover {
    border: 2px solid #D8D8D8;
  }

  .dropZone:hover .dropZone-title {
    color: #1975A0;
  }

  .dropZone-info {
    color: #A8A8A8;
    position: absolute;
    top: 50%;
    width: 100%;
    transform: translate(0, -50%);
    text-align: center;
  }

  ..dropZone-title {
    color: #787878;
  }

  .dropZone input {
    position: absolute;
    cursor: pointer;
    top: 0px;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
  }

  .dropZone-upload-limit-info {
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
  }

  .dropZone-over {
    background: #D8D8D8;
    opacity: 0.8;
  }

  .dropZone-uploaded {
    width: 80%;
    height: 200px;
    position: relative;
    border: 2px dashed #eee;
  }

  .dropZone-uploaded-info {
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #D8D8D8;
    position: absolute;
    top: 50%;
    width: 100%;
    transform: translate(0, -50%);
    text-align: center;
  }

  .removeFile {
    width: 200px;
  }
</style>